export const STATUS_ELIGIBLE = 'ELIGIBLE' as const;
export const STATUS_INELIGIBLE = 'INELIGIBLE' as const;

export const REASON_NO_SLOT = 'NO_SLOT' as const;
export const REASON_INVALID_SLOT_TYPE = 'INVALID_SLOT_TYPE' as const;
export const REASON_NOT_IN_COHORT = 'NOT_QUALIFIED' as const;
export const REASON_NO_SUGGESTIONS = 'NO_SUGGESTIONS' as const;
